import { Component, Vue } from 'vue-property-decorator';
import WithRender from './productreport.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

@WithRender
@Component({
  components: {
    Loading,
    Datepicker
  }
})
export default class ProductReport extends Vue {
  isLoading = false;
  fromDate = new Date();
  toDate = new Date();
  success = true;

  perPage = 100;
  currentPage = 1;
  selectedPage = 1;
  totalRecords = 0;

  items = [];
  fields = [
    {
      key: "product",
      label: "Product",
      sortable: true,
    },
    {
      key: "amount",
      label: "Amount",
      sortable: true,
    },
    {
      key: "discount",
      label: "Discount",
      sortable: true,
    },
    {
      key: "transaction",
      label: "Transactions",
      sortable: true,
    }
  ]

  customFormatter(date: Date) {
    return moment(date).format('yyyy-MM-DD');
  }

  mounted() {
    this.getReport();
  }

  handlePageClick() {
    if (this.currentPage === this.selectedPage)
      return;
    this.currentPage = this.selectedPage;
    this.getReport();
  }

  getReport(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}admin/internal/report/ProductReport?dateFrom=${this.customFormatter(this.fromDate)}&dateTo=${this.customFormatter(this.toDate)}&currentPage=${this.currentPage}&pageSize=${this.perPage}&success=${this.success}`)
      .then(response => {
        this.items = response.data.objectList;
        this.totalRecords = response.data.totalRowCount;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
